import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-working-times-calendar-dialog',
  templateUrl: './working-times-calendar-dialog.component.html',
  styleUrls: ['./working-times-calendar-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatDialogActions, MatButton],
})
export class WorkingTimesCalendarDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<WorkingTimesCalendarDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private _snackBar = inject(MatSnackBar);
  private utils = inject(UtilsService);

  calendarUrl: string;

  ngOnInit() {
    this.calendarUrl = this.data.calendarUrl;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  localSincronize() {
    const url = this.calendarUrl.replace('http', 'webcal').replace('https', 'webcal');
    window.open(url, '_blank');
  }

  googleSincronize() {
    const url = 'https://calendar.google.com/calendar?cid=' + this.calendarUrl + '&pli=1';
    window.open(url, '_blank');
  }

  async copyLink(): Promise<void> {
    await this.utils.copyTextToClipboard(this.calendarUrl);

    this._snackBar.open('Enlace copiado!', 'Undo', { duration: 3000 });
  }
}
